import { takeLatest, put, all, call } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import ApiCollections from "../../configs/services/apiCollections";
import EbayTypes from "./ebay.types";
import * as EbayActions from "./ebay.actions";

/******************** Other Sagas ****************************/

function* fetchEbayStatus() {
  try {
    const response = yield call(ApiCollections.getEbayStatus);
    const status = response?.data || response || {};
    yield put(EbayActions.fetchEbayStatusSuccess(status));
  } catch (error) {
    console.error("Error fetching eBay status:", error);
    Sentry.withScope((scope) => {
      scope.setTag("saga", "fetchEbayStatus");
      scope.setLevel("warning");
      Sentry.captureException(error);
    });
    yield put(EbayActions.fetchEbayStatusFailure(error?.response?.data || error?.message));
  }
}

/******************** Root Saga ****************************/

export function* ebaySagas() {
  yield all([takeLatest(EbayTypes.FETCH_EBAY_STATUS_REQUEST, fetchEbayStatus)]);
}
